<script module>
	export const TABS = {};
</script>

<script>
    import { setContext, onDestroy } from 'svelte';
    import { writable } from 'svelte/store';
    import { goto } from '$app/navigation';
    import { page } from '$app/stores';

    let {
        group = null,
        children
    } = $props();

    export const selectedTab = writable(null);
    const selectedPanel = writable(null);
    const tabs = [];
    const panels = [];
	
    $effect(() => {
        const i = tabs.findIndex(x => x.id === $page.url.searchParams.get(group));
        //console.log(`tab in url=${$page.url.searchParams.get(group)}, tabs=${JSON.stringify(tabs)}, index of url=${i}, index of url=${selectedTab}`);
        if(i > 0 && selectedTab !== tabs[i]) {
            selectedTab.set(tabs[i]);
			selectedPanel.set(panels[i]);
        }
    });

	setContext(TABS, {
		registerTab: tab => {
            tab.group = group;
            tabs.push(tab);
            selectedTab.update(current => ($page.url.searchParams.get(group) === tab?.id ? tab : current) || tab);

            onDestroy(() => {
                const i = tabs.indexOf(tab);
                tabs.splice(i, 1);
                selectedTab.update(current => current === tab ? (tabs[i] || tabs[tabs.length - 1]) : current);
            });
		},

		registerPanel: panel => {
			panels.push(panel);

            const get_params_id = $page.url.searchParams.get(group);
            const get_params_tab_index = get_params_id ? tabs.findIndex(x => get_params_id === x?.id) : -1;

			selectedPanel.update(current => get_params_tab_index > 0 ?  panels[get_params_tab_index] : current || panel);
			
			onDestroy(() => {
				const i = panels.indexOf(panel);
				panels.splice(i, 1);
				selectedPanel.update(current => current === panel ? (panels[i] || panels[panels.length - 1]) : current);
			});
		},

		selectTab: tab => {
			const i = tabs.indexOf(tab);
			selectedTab.set(tab);
			selectedPanel.set(panels[i]);
            if(group && (typeof tab?.id === 'string' || tab?.id instanceof String)) {
                if(tab.id === "")
                    goto("?", { replaceState: true, noScroll: true, keepFocus: true,  });
                else 
                    goto(`?${group}=${tab.id}`, { replaceState: true, noScroll: true, keepFocus: true,  });
            }
		},

		selectedTab,
		selectedPanel
	});
</script>

<div> <!--class="tabs"-->
	{@render children?.()}
</div>

